function d(e, n, t) {
  return new Promise((r) => {
    if ((t == null ? void 0 : t.duration) === 1 / 0)
      throw new Error("Promise-based animations must be finite.");
    const i = e.animate(n, {
      ...t,
      duration: o() ? 0 : t.duration
    });
    i.addEventListener("cancel", r, { once: !0 }), i.addEventListener("finish", r, { once: !0 });
  });
}
function o() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function f(e) {
  return Promise.all(
    e.getAnimations().map((n) => new Promise((t) => {
      const r = requestAnimationFrame(t);
      n.addEventListener("cancel", () => r, {
        once: !0
      }), n.addEventListener("finish", () => r, {
        once: !0
      }), n.cancel();
    }))
  );
}
const s = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new WeakMap();
function c(e) {
  return e ?? { keyframes: [], options: { duration: 0 } };
}
function a(e, n) {
  return n.toLowerCase() === "rtl" ? {
    keyframes: e.rtlKeyframes ?? e.keyframes,
    options: e.options
  } : e;
}
function m(e, n) {
  s.set(e, c(n));
}
function l(e, n, t) {
  const r = u.get(e);
  if (r != null && r[n])
    return a(r[n], t.dir);
  const i = s.get(n);
  return i ? a(i, t.dir) : {
    keyframes: [],
    options: { duration: 0 }
  };
}
export {
  f as a,
  d as b,
  l as g,
  m as s
};
